module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/card1-93aead454daf556cb2ed47dc014621d9.png";